import React from "react";
import { I18n } from "aws-amplify";
// import "./modalconfirm-styles.css";

import * as S from "./styles";

import Logo from "../../../media/img/logo.png";
import IcoConfirm from "../../../media/svg/ico-confirm-modal.svg";
import IcoAlert from "../../../media/svg/ico-alert-modal.svg";

export const ModalBp = ({
  visible,
  bodyText,
  subBodyText,
  okText,
  handleClickOk,
  typeModal,
  cancelText,
  isDanger,
  isAlert,
  onCancel,
  actionBp,
  isLoading,
  children,
  maskClosable,
}) => {
  return (
    <S.MainModal
      isDanger={isDanger}
      centered
      visible={visible}
      onOk={handleClickOk}
      confirmLoading={isLoading}
      okText={okText}
      onCancel={onCancel || handleClickOk}
      cancelText={cancelText || I18n.get("Voltar")}
      wrapClassName={`modalbp ${actionBp}`}
      maskClosable={maskClosable || false}
      cancelButtonProps={{
        style: {
          display: typeModal != "isConfirm" ? "none" : "",
        },
      }}
    >
      <S.Logo>
        {/* <img src={Logo} alt="Ollo" /> */}
      </S.Logo>

      <S.Icone>
        {isAlert ? (
          <img src={IcoAlert} alt="Ico confirm modal" />
        ) : (
          <img src={IcoConfirm} alt="Ico confirm modal" />
        )}
      </S.Icone>
      <S.TextModal>{bodyText}</S.TextModal>
      {subBodyText ? (
        <S.SubText dangerouslySetInnerHTML={{ __html: subBodyText }} />
      ) : null}
      {children ? <S.Content>{children}</S.Content> : null}
    </S.MainModal>
  );
};
